<template>
    <el-radio-group v-show="!init_error" v-model="context" @change="handle_selection_change">
      <template v-for="(option, idx) in radio_options">
        <el-radio 
          :label="option.value"
          :key="idx"
        >
          {{option.label}}
        </el-radio>
        <br/>
      </template>
      <el-date-picker
        :disabled="context!=radio_options[radio_options.length-1].value"
        v-model="local_start_date"
        class="start_date"
        @change="handle_filter_change('start')"
        type="date"
        placeholder="開始日期"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <span style="margin: 0 22px;">至</span>
      <el-date-picker
        :disabled="context!=radio_options[radio_options.length-1].value"
        v-model="local_end_date"
        class="end_date"
        @change="handle_filter_change('end')"
        type="date"
        placeholder="結束日期"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
    </el-radio-group>
</template>

<script>


export default {
    props: ['publish_setting', 'options', 'start_date', 'end_date', 'handle_dynamic_form_update'],
    data() {
        return {
          init_error: false,
          context: null,
          radio_options: null,
          local_start_date: null,
          local_end_date: null,
          valid_start_date: null,
          valid_end_date: null,
          pickerOptions: {
            disabledDate(time) {
              return time.getTime() < Date.now();
            },
          },
        }
    },
    watch: {
    },
    created: function () {
        this.init()
    },
    methods: {
        init() {
          console.log('RadioWithDatePicker: init: publish_setting=', this.publish_setting)
          if (!this.options) {
              console.warn('RadioWithDatePicker: invalid options')
              this.init_error = true
              return
          }

          this.context = this.publish_setting
          this.radio_options = this.options
          this.valid_start_date = this.local_start_date = this.start_date
          this.valid_end_date = this.local_end_date = this.end_date
        },
        handle_selection_change (val) {
          console.log('handle_selection_change: ', val)
          if (this.handle_dynamic_form_update) {
            this.handle_dynamic_form_update('publish_setting', JSON.parse(JSON.stringify(val)))
          }
        },
        handle_filter_change(scope) {
          switch(scope) {
            case 'start':
              console.log('handle_filter_change (start_date): ', this.local_start_date)
              if(this.local_start_date > this.local_end_date) {
                this.notify_message(this.ERROR.LEVEL.WARN, '預定下架日期需晚於預定上架日期', '')
                this.local_start_date = this.valid_start_date
              }else {
                this.valid_start_date = this.local_start_date
                if(this.handle_dynamic_form_update) {
                  this.handle_dynamic_form_update("start_date", JSON.parse(JSON.stringify(this.valid_start_date)))
                }
              }
              break
            case 'end':
              console.log('handle_filter_change (end_date): ', this.local_end_date)
              if(this.local_start_date > this.local_end_date) {
                this.notify_message(this.ERROR.LEVEL.WARN, '預定下架日期需晚於預定上架日期', '')
                this.local_end_date = this.valid_end_date
              }else {
                this.valid_end_date = this.local_end_date
                if(this.handle_dynamic_form_update) {
                  this.handle_dynamic_form_update("end_date", JSON.parse(JSON.stringify(this.valid_end_date)))
                }
              }
              break
          }
          
        },
    }
};
</script>

<style lang="scss" scoped>
.el-radio {
    margin-bottom: 10px;
}
</style>
